// Generated by purs version 0.13.0
"use strict";
var Chip_Action = require("../Chip.Action/index.js");
var Chip_Action_MovePlayer = require("../Chip.Action.MovePlayer/index.js");
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Chip_Model_Inventory = require("../Chip.Model.Inventory/index.js");
var Chip_Model_Item = require("../Chip.Model.Item/index.js");
var Chip_Model_Tile = require("../Chip.Model.Tile/index.js");
var Chip_Mutation_Direction = require("../Chip.Mutation.Direction/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var slide = function ($copy_level) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(level) {
        var v = Data_Map_Internal.lookup(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
            return "y";
        }))(Data_Ord.ordInt))()(new Data_Symbol.IsSymbol(function () {
            return "x";
        }))(Data_Ord.ordInt)))(level.player.pos)(level.tiles);
        if (v instanceof Data_Maybe.Just && (v.value0 instanceof Chip_Model_Tile.Force && !Chip_Model_Inventory.has(Chip_Model_Item.SuctionBoots.value)(level.inventory))) {
            $tco_done = true;
            return Chip_Action_MovePlayer.movePlayer(false)(v.value0.value0)(level);
        };
        if (v instanceof Data_Maybe.Just && (v.value0 instanceof Chip_Model_Tile.Ice && !Chip_Model_Inventory.has(Chip_Model_Item.SkiSkates.value)(level.inventory))) {
            var v1 = Chip_Action_MovePlayer.movePlayer(false)(level.player.direction)(level);
            if (v1.actions.length === 1 && (v1["actions"][0] instanceof Chip_Action.PlaySound && (v1["actions"][0].value0 instanceof Chip_Action.Oof && Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                return "y";
            }))(Data_Eq.eqInt))()(new Data_Symbol.IsSymbol(function () {
                return "x";
            }))(Data_Eq.eqInt)))(v1.result.player.pos)(level.player.pos)))) {
                $copy_level = {
                    player: {
                        pos: level.player.pos,
                        direction: Chip_Mutation_Direction.invert(level.player.direction),
                        turnedAt: level.player.turnedAt,
                        movedAt: level.player.movedAt
                    },
                    tiles: level.tiles,
                    inventory: level.inventory,
                    chipsLeft: level.chipsLeft,
                    hint: level.hint,
                    enemies: level.enemies,
                    blocks: level.blocks,
                    trapConnections: level.trapConnections,
                    ticksLeft: level.ticksLeft,
                    tick: level.tick
                };
                return;
            };
            $tco_done = true;
            return v1;
        };
        if (v instanceof Data_Maybe.Just && (v.value0 instanceof Chip_Model_Tile.IceCorner && !Chip_Model_Inventory.has(Chip_Model_Item.SkiSkates.value)(level.inventory))) {
            var $12 = Data_Eq.eq(Chip_Model_Direction.eqDirection)(level.player.direction)(v.value0.value0);
            if ($12) {
                $tco_done = true;
                return Chip_Action_MovePlayer.movePlayer(false)(Chip_Mutation_Direction.toRight(v.value0.value0))(level);
            };
            $tco_done = true;
            return Chip_Action_MovePlayer.movePlayer(false)(Chip_Mutation_Direction.invert(v.value0.value0))(level);
        };
        $tco_done = true;
        return Chip_Action.inactive(level);
    };
    while (!$tco_done) {
        $tco_result = $tco_loop($copy_level);
    };
    return $tco_result;
};
module.exports = {
    slide: slide
};
